module.exports = __webpack_public_path__ + "img/0Q3A7263_L_BlackMatted_MockedUp.a1443d88.jpg";